/**
 * @flow
 * @relayHash 535b7a7dd137a3f1b75a5799c40e9c0a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DocumentStatus = "ACTIVE" | "DELETED" | "OLD" | "OLD_SAVE" | "PENDING" | "RETIRED" | "SAVED" | "SCHEDULED" | "%future added value";
export type AcceptanceReportPageQueryVariables = {|
  after?: ?string,
  first?: ?number,
  sort?: ?string,
|};
export type AcceptanceReportPageQueryResponse = {|
  +blocSystemDocumentTemplatesAcceptance: ?{|
    +blocSystemDocumentTemplates: ?{|
      +totalCount: ?number,
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +systemDocumentTemplate: {|
            +pk: ?number,
            +status: ?DocumentStatus,
            +name: string,
            +category: {|
              +name: string
            |},
          |},
          +publishDate: ?string,
          +document: ?{|
            +pk: ?number,
            +status: ?DocumentStatus,
          |},
        |}
      |}>,
    |},
    +buckets: ?any,
    +error: ?{|
      +statusCode: ?number,
      +message: ?string,
    |},
  |}
|};
export type AcceptanceReportPageQuery = {|
  variables: AcceptanceReportPageQueryVariables,
  response: AcceptanceReportPageQueryResponse,
|};
*/


/*
query AcceptanceReportPageQuery(
  $after: String
  $first: Int
  $sort: String
) {
  blocSystemDocumentTemplatesAcceptance(sort: $sort) {
    blocSystemDocumentTemplates(after: $after, first: $first) {
      totalCount
      edges {
        node {
          systemDocumentTemplate {
            pk
            status
            name
            category {
              name
              id
            }
            id
          }
          publishDate
          document {
            pk
            status
            id
          }
          id
        }
      }
    }
    buckets
    error {
      statusCode
      message
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "after",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sort",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "sort",
    "variableName": "sort",
    "type": "String"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after",
    "type": "String"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first",
    "type": "Int"
  }
],
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalCount",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pk",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "publishDate",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "buckets",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "error",
  "storageKey": null,
  "args": null,
  "concreteType": "ErrorType",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "statusCode",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "message",
      "args": null,
      "storageKey": null
    }
  ]
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "AcceptanceReportPageQuery",
  "id": "3f55d89636bcab882a26ea2386e6307a",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "AcceptanceReportPageQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "blocSystemDocumentTemplatesAcceptance",
        "storageKey": null,
        "args": v1,
        "concreteType": "BlocSystemDocumentTemplateListBucketsType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "blocSystemDocumentTemplates",
            "storageKey": null,
            "args": v2,
            "concreteType": "BlocSystemDocumentTemplateCountableConnection",
            "plural": false,
            "selections": [
              v3,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "BlocSystemDocumentTemplateCountableEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BlocSystemDocumentTemplateType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "systemDocumentTemplate",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SystemDocumentTemplateType",
                        "plural": false,
                        "selections": [
                          v4,
                          v5,
                          v6,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "category",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CategoryType",
                            "plural": false,
                            "selections": [
                              v6
                            ]
                          }
                        ]
                      },
                      v7,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "document",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "DocumentType",
                        "plural": false,
                        "selections": [
                          v4,
                          v5
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          v8,
          v9
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "AcceptanceReportPageQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "blocSystemDocumentTemplatesAcceptance",
        "storageKey": null,
        "args": v1,
        "concreteType": "BlocSystemDocumentTemplateListBucketsType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "blocSystemDocumentTemplates",
            "storageKey": null,
            "args": v2,
            "concreteType": "BlocSystemDocumentTemplateCountableConnection",
            "plural": false,
            "selections": [
              v3,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "BlocSystemDocumentTemplateCountableEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BlocSystemDocumentTemplateType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "systemDocumentTemplate",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SystemDocumentTemplateType",
                        "plural": false,
                        "selections": [
                          v4,
                          v5,
                          v6,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "category",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CategoryType",
                            "plural": false,
                            "selections": [
                              v6,
                              v10
                            ]
                          },
                          v10
                        ]
                      },
                      v7,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "document",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "DocumentType",
                        "plural": false,
                        "selections": [
                          v4,
                          v5,
                          v10
                        ]
                      },
                      v10
                    ]
                  }
                ]
              }
            ]
          },
          v8,
          v9
        ]
      }
    ]
  }
};
})();
node.text = "query AcceptanceReportPageQuery(\n  $after: String\n  $first: Int\n  $sort: String\n) {\n  blocSystemDocumentTemplatesAcceptance(sort: $sort) {\n    blocSystemDocumentTemplates(after: $after, first: $first) {\n      totalCount\n      edges {\n        node {\n          systemDocumentTemplate {\n            pk\n            status\n            name\n            category {\n              name\n              id\n            }\n            id\n          }\n          publishDate\n          document {\n            pk\n            status\n            id\n          }\n          id\n        }\n      }\n    }\n    buckets\n    error {\n      statusCode\n      message\n    }\n  }\n}\n";
(node/*: any*/).hash = '88f5aa8e70bb6f94dd75b153a229980a';
module.exports = node;
